// src/pages/HomePage.jsx
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { Container } from "components/misc/Layouts";
import fethiyasar from "images/yenimahalle/buttonbg_fethiyasar.jpg";
import ebelediye from "images/yenimahalle/buttonbg_ebelediye.jpg";
import duyurular from "images/yenimahalle/buttonbg_duyurular.jpg";
import hizmetrehberi from "images/yenimahalle/buttonbg_hizmetlerimiz.jpg";
// import ebelediye from "images/yenimahalle/mainbutton_ebelediye.jpg";
// import duyurular from "images/yenimahalle/mainbutton_duyurular.jpg";
// import hizmetrehberi from "images/yenimahalle/mainbutton_hizmetrehberi.jpg";
import yardimportali from "images/yenimahalle/mainbutton_yardimportali.jpg";
import { SiFacebook, SiX, SiYoutube, SiInstagram } from "react-icons/si";

// Primary wrapper with top negative margin
const PrimaryBackgroundContainer = tw.div`-mt-8 relative`;

// Grid: default 1 col, md:2 cols, lg+:5 cols; uniform gaps
const ButtonsGrid = tw.div`
  w-full
  px-4 sm:px-8
  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5
  gap-4 sm:gap-4 md:gap-4 lg:gap-4 xl:gap-4
`;

// Standard button link styling with same border-radius
const ButtonLink = styled.a`
  ${tw`
    relative flex flex-col items-center justify-end
    text-white text-sm font-bold
    rounded overflow-hidden
    transition-all duration-300 cursor-pointer
    focus:outline-none focus:shadow-outline
  `}
  box-shadow: 0 -4px 6px -4px rgba(0, 0, 0, 0.75);
  height: 0;
  padding-bottom: 70%;
  background-size: 120%;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-size 0.4s ease-in-out;
  &:hover { background-size: 130%; }
  .buttonText {
    ${tw`absolute bottom-0 left-0 right-0 text-center p-2 z-10`}
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
  }
`;

// Social media card uses exact same radius and participates in same gap system
const SocialArea = styled.div`
  ${tw`relative rounded overflow-hidden`}
  height: 0;
  padding-bottom: 70%;
  background: transparent;
  /* md: span full row and adjust height for a squarer shape */
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-column: 1 / -1;
    padding-bottom: 20%;
  }
`;

// Inner grid for social icons with responsive layout with responsive layout
const InnerGrid = styled.div`
  ${tw`absolute inset-0 grid gap-2`}
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
`;

// Each social icon link: only icon scales on hover
const SocialLink = styled.a`
  ${tw`flex items-center justify-center text-white rounded`}
    ${({ bg }) => `background: ${bg};`}

  width: 100%;
  height: 100%;
  svg {
    width: 40%;
    height: 40%;
    transition: transform 0.5s;
  }
  &:hover svg {
    transform: scale(1.2);
  }
`;

export default function HomePage({ pushDownFooter = true }) {
  return (
    <Container css={pushDownFooter && tw`mb-20 lg:mb-24`}>
      <PrimaryBackgroundContainer>
        <ButtonsGrid>
          {/* Four main cards */}
          <ButtonLink href="/Icerik/Fethi-Yasar/1" style={{ backgroundImage: `url(${fethiyasar})` }}>
            <span className="buttonText">FETHİ YAŞAR</span>
          </ButtonLink>
          <ButtonLink href="/Yonlendirme/eBelediye/2" style={{ backgroundImage: `url(${ebelediye})` }}>
            <span className="buttonText">E-BELEDİYE</span>
          </ButtonLink>
          <ButtonLink href="/Duyurular" style={{ backgroundImage: `url(${duyurular})` }}>
            <span className="buttonText">DUYURULAR</span>
          </ButtonLink>
          <ButtonLink href="/Yonlendirme/Hizmetlerimiz/1" style={{ backgroundImage: `url(${hizmetrehberi})` }}>
            <span className="buttonText">HİZMET REHBERİ</span>
          </ButtonLink>
          <ButtonLink href="https://hizmet.yenimahalle.bel.tr/tr-TR/Company?id=24&t=QGLLH" target="_blank" style={{ backgroundImage: `url(${yardimportali})` }}>
            <span className="buttonText">YARDIM PORTALI</span>
          </ButtonLink>
          {/* Social media card */}
          {/* <SocialArea>
            <InnerGrid>
              <SocialLink
                href="https://www.facebook.com/YenimahalleBelediyesi"
                target="_blank" rel="noopener noreferrer"
                bg="#1877F2"
              >
                <SiFacebook />
              </SocialLink>
              <SocialLink
                href="https://x.com/yenimahallebld"
                target="_blank" rel="noopener noreferrer"
                bg="#1DA1F2"
              >
                <SiX />
              </SocialLink>
              <SocialLink
                href="https://www.youtube.com/watch?v=wYJGSYKd9rs"
                target="_blank" rel="noopener noreferrer"
                bg="#FF0000"
              >
                <SiYoutube />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/yenimahallebelediyesi/?hl=en"
                target="_blank" rel="noopener noreferrer"
                bg="linear-gradient(45deg,#405DE6,#833AB4,#E1306C,#FD1D1D)"
              >
                <SiInstagram />
              </SocialLink>
            </InnerGrid>
          </SocialArea> */}
        </ButtonsGrid>
      </PrimaryBackgroundContainer>
    </Container>
  );
}
